 //NavLinks.js

 import './NavBar.css';
 import { SampleAudioTable } from '../../audiotable_code';
 const NavLinks = () =>{
     return(
         <nav className="NavLinks">
         <SampleAudioTable/>
     </nav>
     )
 }

 export default  NavLinks;

 //You'll style this component by targetting the NavLinks classname above
